import React from 'react';
import cn from 'classnames';

const PriorityModifier = ({ designer, updateDesignerPriority }) => {
  return (
    <span className='priorityModifyier'>
      <PriorityControls
        designer={designer}
        onUpdate={updateDesignerPriority}
      >
        {designer.priority === 5 ? 'D' : designer.priority}
      </PriorityControls>
    </span>
  );
};

const PriorityControls = ({ children, onUpdate, designer }) => {
  const handleOnIncrease = () => {
    onUpdate(Math.max(1, designer.priority - 1));
  };
  const handleOnDecrease = () => {
    onUpdate(Math.min(5, designer.priority + 1));
  };

  return (
    <div className="priorityControlls">
      <div className="controll priorityControlls_increase" onClick={handleOnIncrease}>
        ▲
      </div>
      <div className={cn('priorityValue', {'-designer-disabled': designer.priority >= 5})}>{children}</div>
      <div className="controll priorityControlls_decrease" onClick={handleOnDecrease}>
        ▼
      </div>
    </div>
  );
};

export default PriorityModifier;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/PriorityModifier.js